/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable consistent-return */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { useEffect } from 'react'

import { GladSdkMyPlaceCustomParams } from '@web/components/Advertisement/types'
import { useGlobalStaticStateContext } from '@web/hooks/useGlobalStaticState'
import useLazyLoadScript from '@web/hooks/useLazyLoadScript'
import links from '@web/libs/constants/links'

import { AdPage, AdType } from './Advertisement'
import { initAd, initAdSdk } from './utils'

export interface AdInitProps {
  adSlotElementIds: string[]
  userIdno: GladSdkMyPlaceCustomParams['userIdno']
  /**
   * 광고 타입
   * 내부적으로는 adUnitId 로 쓰입니다.
   */
  type: AdType
  /**
   * 광고 노출 지면
   * 내부적으로는 customParam.category 로 쓰입니다.
   */
  page: AdPage
}

export const useAdvertisement = ({ adSlotElementIds, type, userIdno, page }: AdInitProps) => {
  const { isFromMapsApp, isMobile } = useGlobalStaticStateContext()

  const skipAd = !isMobile || (isFromMapsApp && type === AdType.SMART_CHANNEL) || !adSlotElementIds.length

  const { error, loading } = useLazyLoadScript(links.AD, {
    onLoad: initAdSdk,
    skip: skipAd,
  })

  useEffect(() => {
    if (skipAd || loading || error) return

    initAd({
      adSlotElementIds,
      adUnitId: type,
      // 스마트 채널 외 광고 타입은 같은 광고소재가 노출되지 않게 dedupe 적용
      dedupe: type !== AdType.SMART_CHANNEL,
      customParam: {
        userIdno,
        category: page,
      },
    })
  }, [skipAd, loading, error, adSlotElementIds.join(':')])

  return { skipAd: skipAd || error }
}
